import {Component, OnInit} from '@angular/core';
import {TourStep} from '../../../tour/tour-step';
import {StateParamsService} from '../../../services/ajs-state-params.service';
import {TourService} from '../../../tour/tour.service';
import {PopoverPosition} from '@mandae/ng-popover';

@Component({
  selector: 'mandae-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss']
})
export class ProfileSettingsComponent implements OnInit {

  constructor (
    private state: StateParamsService,
    private tour: TourService,
  ) { }

  async ngOnInit() {
    if (this.state.tour) {
      this.startTour();
    }
  }

  private startTour() {
    const stepsConfig: TourStep[] = [
      {
        title: 'Configure sua conta',
        text: 'Altere seus dados de perfil, cadastre contatos e configure a integração de sua plataforma.',
        attachTarget: () => document.querySelector('.menu-container a[href*="/configuracoes-do-usuario"]'),
      },
      {
        title: 'Gerencie seus dados',
        text: 'Altere seus dados cadastrais e sua senha de acesso ao painel da Mandaê.',
        attachTarget: () => document.querySelector('app-toolbar .mat-tab-link:nth-child(1)'),
      },
      {
        title: 'Aceitar devolução',
        text: 'Mantenha selecionado caso você queira receber as devoluções de suas encomendas',
        attachTarget: () => document.querySelector('label[class="return-tooltip"]'),
        preferredPosition: PopoverPosition.Right,
        next: {
          text: 'Ir para Contatos',
          action: (ev, ref) => {
            ref.close('to_next_section');
            this.state.go('contato', { tour: true });
          },
        },
      },
    ];

    const steps = this.tour.makeTour(stepsConfig);

    this.tour.start(steps).subscribe();
  }

}
